/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {TiGridComponent as ɵa} from './lib/ti-grid.component';